import { Patient } from "../patient/patient.model";

export class Plan {
  id?: number;
  name: string;
  patient: Patient;
  createdAt?: Date;

  constructor() {
    this.id = null;
    this.name = "";
    this.patient = null;
    this.createdAt = null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan/plan.model.ts